import { Link } from 'react-router-dom'
import { useAppStore } from '../../store/useAppStore'
import { useUsersCount } from '../../hooks/useApi'
import logo from '../../assets/images/logo.svg'
import avatar from '../../assets/images/avatar.png'

const Header = () => {
  const { user } = useAppStore()
  const { data: usersCount } = useUsersCount()

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="header-left">
            <img src={logo} alt="Pauline Cake" />
            {usersCount && (
              <p className="users-count">
                {usersCount.users_count.toLocaleString()} пользователя
              </p>
            )}
          </div>

          <div className="header-right">
            <Link to="/profile" className="user-avatar">
              {user?.photo_url ? (
                <img src={user.photo_url} alt={user.first_name} />
              ) : (
                <img src={avatar} alt="Аватар" className="avatar-image" />
              )}
            </Link>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
